import { render } from "./AppAuth.vue?vue&type=template&id=81dd3598"
import script from "./AppAuth.vue?vue&type=script&lang=js"
export * from "./AppAuth.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__